export enum PHV_CHOICE {
  TAETIGKEIT = 'taetigkeit',
  ZUGANGSWEG = 'zugangsweg',
  DIENSTEIGENSCHAFT = 'diensteigenschaft',
  REGRESS_HAFTPFLICHT = 'regressHaftpflicht',
  SCHADEN_EIGENTUM_SCHULE = 'schadenEigentumSchule',
  ABHANDENGEKOMMENE_GEGENSTAENDE = 'abhandengekommeneGegenstaende',
  DIENSTSCHLUESSEL = 'dienstschluessel',
  KASSENFEHLBETRAEGE = 'kassenfehlbetraege',
  ERWEITERTE_VERMOEGENSSCHADEN_DECKUNG = 'erweiterteVermoegensschadenDeckung',
  DIENSTHUNDE_HAFTPFLICHT = 'dienstHundeHaftpflicht',
  DIENSTPFERDE_HAFTPFLICHT = 'dienstPferdeHaftpflicht',
}
